import { useAuthStore } from '@sentinel/web-core';
import type { Destination, Me, TokenGrant } from '@sentinel/shared';
import { endpoints } from '../api/endpoints';

/** The page each context opens on. */
export function homeOf(me: Me): '/platform' | '/' {
  return me.context === 'console' ? '/platform' : '/';
}

/** The grant that opens a destination, or null when it is the current context. A support
 *  window is entered from the console, so an organization session passes through it first. */
export async function grantFor(destination: Destination, me: Me): Promise<TokenGrant | null> {
  if (destination.current) return null;
  if (destination.kind === 'organization')
    return endpoints.auth.switchOrganization(destination.organizationId);
  if (destination.kind === 'console') return endpoints.auth.enterConsole();
  if (me.context !== 'console')
    useAuthStore.getState().applyGrant(await endpoints.auth.enterConsole());
  return endpoints.platform.enter(destination.grantId);
}
